import { ApplicationState } from '@app/store'
import {
  IGlobalConfigurationState,
  selectConfiguration,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import ConnectionsListPage from '../components/ConnectionsListPage'
import {
  actionCreators,
  IConnectionsListState,
  selectConnectionType,
  selectError,
  selectFilterText,
  selectGroup,
  selectIsLoading,
  selectItems,
  selectScope,
  selectSortOrder,
  selectTotalItems,
} from '../modules/connectionsList'

export default withRouter(
  connect(
    createStructuredSelector<
      ApplicationState,
      IConnectionsListState & IGlobalConfigurationState
    >({
      configuration: selectConfiguration(),
      connectionType: selectConnectionType(),
      error: selectError(),
      filterText: selectFilterText(),
      group: selectGroup(),
      isLoading: selectIsLoading(),
      items: selectItems(),
      scope: selectScope(),
      sortOrder: selectSortOrder(),
      totalItems: selectTotalItems(),
    }),
    actionCreators,
  )(ConnectionsListPage),
)
